export var EStrategy;
(function (EStrategy) {
    EStrategy["CIP30"] = "cip30";
    EStrategy["CIP45"] = "cip45";
})(EStrategy || (EStrategy = {}));
//# sourceMappingURL=types.js.map